import { React, useState, useEffect, useRef } from "react";
import { addNewField } from "../../../../Services/customerServices";
import { getCustomerFields } from "../../../../Services/fieldsServices";
import { getStages } from "../../../../Services/optionService";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import RadioElement from "../../../../Components/UiComponents/RadioElement";
import DataTable from "../../../../Components/UiComponents/DataTable";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";

export default function CreateNewField(props) {
	const [groups, setGroups] = useState([
		{ id: "option1", label: "", text: "", score: 0, status: "active" },
	]);
	const [formData, setFormData] = useState({
		option_names: "",
		factor: null,
		win_stage: null,
		option_type: null,
		weightage: "",
		option_status: "",
		groups: groups,
	});
	const [errors, setErrors] = useState({});
	const [visible, setVisible] = useState(false);
	const [costmerReferenceData, setCostmerReferenceData] = useState([]);
	const [stages, setStages] = useState([]);
	const [status] = useState([
		{ option: "Yes", value: "Yes" },
		{ option: "No", value: "No" },
	]);
	const [groupErrors, setGroupErrors] = useState({});
	const [dialogWidth, setDialogWidth] = useState("42%");

	const factors = [
		{ name: "None", code: "None" },
		{ name: "Internal", code: "Internal" },
		{ name: "External", code: "External" },
	];

	const projectStages = [
		{ name: "None", code: "None" },
		{ name: "BD/Long Shot", code: "BD/Long Shot" },
		{ name: "PQQ", code: "PQQ" },
		{ name: "ITT", code: "ITT" },
	];
	const [loading, setLoading] = useState(false);

	const toastRef = useRef();

	useEffect(() => {
		const updateWidth = () => {
			if (window.innerWidth <= 768) {
				setDialogWidth("90%"); // Width for mobile devices
			} else {
				setDialogWidth("42%"); // Default width
			}
		};

		window.addEventListener("resize", updateWidth);
		updateWidth(); // Call once to set initial value

		return () => window.removeEventListener("resize", updateWidth);
	}, []);

	useEffect(() => {
		getStage();
	}, []);

	// Function to get stages fields data
	const getStage = async function () {
		try {
			const getStage = await getStages();
			getStage.data[0].option_choice.push({ label: "Common", text: "Common", status: "active" })
			setStages(getStage.data[0].option_choice);
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: "Failed to fetch stages data"
			});
		}
	};

	const handleAddGroup = () => {
		const newGroupId = `option${formData.groups.length + 1}`;
		const newGroup = {
			id: newGroupId, // or generate a unique id in a different way
			label: "",
			score: null,
			text: "",
			status: "active",
		};
		setFormData({
			...formData,
			groups: [...formData.groups, newGroup],
		});
	};

	const handleRemoveGroup = (groupId) => {
		const updatedGroups = formData.groups.filter(
			(group) => group.id !== groupId
		);
		setFormData({
			...formData,
			groups: updatedGroups,
		});
	};

	// Function to get customer fields data
	const getCustomerField = async () => {
		try {
			if (props.customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			const customerDataResponse = await getCustomerFields(props.customerId);
			setCostmerReferenceData(customerDataResponse?.data?.reference_data);
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: "Failed to fetch customer data"
			});
		}
	};

	const handleGroupChange = (groupId, field, value) => {
		const updatedGroups = formData.groups.map((group) =>
			group.id === groupId ? { ...group, [field]: value } : group
		);
		setFormData({
			...formData,
			groups: updatedGroups,
		});
	};

	const createNewField = async (formData) => {
		let finaldata = {
			option_names: formData?.option_names,
			factor: formData.factor?.name,
			win_stage: formData.win_stage?.name,
			option_type: formData.option_type.label,
			weightage: formData.weightage,
			display_name: formData.display_name,
			option_status: formData?.option_status === "Yes" ? "true" : "false",
			option_choice: option,
		};

		try {
			if (props.customerId === null) {
				toastRef.current.showToast({
					type: 'error',
					message: 'Missing customer ID'
				});
				return;
			}
			setLoading(true)
			const customerData = await addNewField(props.customerId, finaldata);
			setVisible(false);
			props.onHide();
			setFormData({
				option_names: "",
				factor: null,
				win_stage: null,
				option_type: null,
				weightage: "",
				option_status: "",
				groups: groups,
			});
			getCustomerField();
			toastRef.current.showToast({
				type: 'success',
				message: "Field Created Successfully"
			})
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: "Failed to create field"
			});
		} finally {
			setLoading(false)
		}
	};

	const closePopup = () => {
		setVisible(false);
		setFormData({
			option_names: "",
			factor: null,
			win_stage: null,
			option_type: null,
			weightage: "",
			option_status: "",
			groups: groups,
		});
		setOption([{ id: "option0", label: "", text: "", status: "active" }]);
		props.onHide();
		setErrors({});
		setGroupErrors({});
	};

	const handleSubmit = (e) => {
		setLoading(true)
		e.preventDefault();
		const newErrors = {};

		// Validate option_names
		if (!formData.option_names) {
			newErrors.option_names = "required";
		}

		// Validate factor
		if (!formData.factor) {
			newErrors.factor = "required";
		}

		// Validate win_stage
		if (!formData.win_stage) {
			newErrors.win_stage = "required";
		}

		// Validate option_type
		if (!formData.option_type) {
			newErrors.option_type = "required";
		}

		// Validate weightage
		if (!formData.weightage) {
			newErrors.weightage = "required";
		}


		// Check for errors in group fields
		const newGroupErrors = {};
		option.forEach((group) => {
			if (!group.label) {
				newGroupErrors[group.id] = {
					...newGroupErrors[group.id],
					option_label: "required",
				};
			}
		});

		if (
			Object.keys(newErrors).length > 0 ||
			Object.keys(newGroupErrors).length > 0
		) {
			setLoading(false)
			setErrors(newErrors);
			setGroupErrors(newGroupErrors);
			return;
		}
		const data = props?.customerDataAll?.reference_data || [];

		const firstIndex = data?.findIndex(
			(opt) =>
				opt.option_names && // Ensure opt.option_name exists
				formData.option_names && // Ensure formData.option_names exists
				opt.option_names.toUpperCase() === formData.option_names.toUpperCase()
		);

		if (firstIndex !== -1) {
			setLoading(false);
			// If a duplicate is found, update error state or display a message
			toastRef.current.showToast({
				type: 'error',
				message: "Duplicate Reference Field"
			});
			return;
		}

		// If no errors and no duplicates, proceed with form submission
		if (Object.keys(newErrors).length === 0 && Object.keys(newGroupErrors).length === 0) {
			createNewField(formData);
			setErrors({});
			setGroupErrors({});
			setFormData({
				option_names: "",
				factor: null,
				win_stage: null,
				option_type: null,
				weightage: "",
				option_status: "",
				groups: groups,
			});
			setOption([{ id: "option0", label: "", text: "", status: "active" }]);
		}
		setLoading(false);
	};

	const handleInputChange = (field, value) => {
		setFormData({
			...formData,
			[field]: value,
		});
	};

	// Popup data table
	const [option, setOption] = useState([
		{ id: "option0", label: "", text: "", status: "active" },
	]);

	const [selectedOption, setSelectedOption] = useState([]);

	const handleDeleteOption = (data) => {
		const updatedOptions = option.filter(row => row.id != data.id);
		setOption(updatedOptions);
		setSelectedOption([]);
	};

	function generateRandomID() {
		const hexChars = '0123456789abcdef';
		let result = '';
		for (let i = 0; i < 24; i++) {
			result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
		}
		return result;
	}

	const handleAddOption = () => {
		const newRow = {
			id: generateRandomID(),
			label: "",
			text: "",
			status: "active",
		};
		setOption([...option, newRow]);
	};

	const onCheckboxChange = (e, row) => {
		const updatedOptions = e.checked
			? [...selectedOption, row.id]
			: selectedOption.filter((optionId) => optionId !== row.id);

		setSelectedOption(updatedOptions);
	};

	const onTextChange = (index, field) => (e) => {
		const newRows = [...option];
		if (field === "score") {
			newRows[index][field] = e.value;
		} else {
			newRows[index][field] = e.target.value;
		}
		setOption(newRows);
	};

	//  Popup data table Ends..


	const labelEditor = (rowData, column) => {
		if (rowData.rowIndex == undefined) {
			rowData['rowIndex'] = 0
		}
		return (
			<InputTextElementElement
				value={rowData["label"]}
				onChange={onTextChange(rowData?.rowIndex, "label")}
				placeholder="Value"
			/>
		);
	};

	const textEditor = (rowData, column) => {
		if (rowData.rowIndex == undefined) {
			rowData['rowIndex'] = 0
		}
		return (
			<InputTextElementElement
				value={rowData["text"]}
				onChange={onTextChange(rowData?.rowIndex, "text")}
				placeholder="Text"
			/>
		);
	};

	const scoreEditor = (rowData, column) => {
		if (rowData.rowIndex == undefined) {
			rowData['rowIndex'] = 0
		}
		return (
			<InputNumber
				value={rowData['score']}
				onChange={onTextChange(rowData?.rowIndex, "score")}
				placeholder="Score"
				mode="decimal"
				aria-describedby="username-help"
				showButtons
				className="d-flex"
			/>
		);
	};

	const actionBodyTemplate = (rowData) => {
		return (
			<i
				className="pi pi-trash"
				onClick={() => handleDeleteOption(rowData)}
			/>
		);
	};

	const renderFooter = (a) => {
		return (
			<div className="cancel-footer">
				<div className='align-center justify-end pb-0'>
					<ButtonElement label="Cancel" className="cancel-new-button" onClick={() => { closePopup() }} />
					<ButtonElement type="submit" label="Save" className="save-button" onClick={handleSubmit} />
				</div>
			</div>
		);
	}

	const columns = [
		{ field: "label", header: "Label", editor: labelEditor, body: labelEditor, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "score", header: "Score", editor: scoreEditor, body: scoreEditor, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "text", header: "Text", editor: textEditor, body: textEditor, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "text1", header: "", body: actionBodyTemplate, headerClassName: "header-datatable", className: 'row-datatable' }
	]

	const rowClick = async (data) => {
		console.log("data")
	};

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			<Dialog
				header="New Reference Field"
				visible={visible ? visible : props.visible}
				position={props.position}
				style={{ width: dialogWidth }}
				onHide={() => {
					closePopup();
				}}
				draggable={false}
				resizable={false}
				footer={renderFooter()}
			>
				<div className="new-field">
					<form onSubmit={handleSubmit}>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{props.customerControlFields?.tables[0]?.headers[3]?.display_name}
								</label>
							</div>
							<div className="col pr-0">
								<InputTextElementElement
									id="refField"
									value={formData.option_names}
									onChange={(e) => handleInputChange("option_names", e.target.value)}
									required
									className="w-full"
								/>
								{errors.option_names && (
									<small className="text-danger">
										{errors.option_names}
									</small>
								)}
							</div>

						</div>
						<div className="form-group row align-items-center mt-0 mb-0" >
							<div className="col-md-4 text-left pl-0">
								<label className="form-label text-left">
									{
										props.customerControlFields?.tables[0]?.headers[4]
											?.display_name
									}
								</label>
							</div>
							<div className="col pr-0">
								<DropdownElement
									value={formData.factor}
									onChange={(e) => handleInputChange("factor", e.value)}
									id="factor"
									options={(factors != undefined && factors.length > 0) ? factors : []}
									optionLabel="name"
									placeholder="-- Please select --"
									className="w-full"
								/>
								{errors.factor && (
									<small className="text-danger">
										{errors.factor}
									</small>
								)}
							</div>
						</div>

						<div className="form-group row align-items-center mt-0 mb-0" >
							<div className="col-md-4 text-left pl-0">
								<label className="form-label text-left">
									{
										props.customerControlFields?.tables[0]?.headers[5]
											?.display_name
									}
								</label>
							</div>
							<div className="col pr-0">
								<DropdownElement
									value={formData.win_stage}
									onChange={(e) => handleInputChange("win_stage", e.value)}
									options={(projectStages != undefined && projectStages.length > 0)? projectStages : []}
									optionLabel="name"
									placeholder="-- Please select --"
									className="w-full"
								/>
								{errors.win_stage && (
									<small className="text-danger">
										{errors.win_stage}
									</small>
								)}
							</div>
						</div>

						<div className="form-group row align-items-center mt-0 mb-0">
							<div className="col-md-4 text-left pl-0">
								<label className="form-label text-left">
									{
										props.customerControlFields?.tables[0]?.headers[6]
											?.display_name
									}
								</label>
							</div>
							<div className="col pr-0">
								<DropdownElement
									value={formData.option_type}
									onChange={(e) => handleInputChange("option_type", e.value)}
									options={(stages != undefined && stages.length > 0) ? stages : []}
									optionLabel="text"
									placeholder="-- Please select --"
									className="w-full"
								/>
								{errors.option_type && (
									<small className="text-danger">
										{errors.option_type}
									</small>
								)}
							</div>
						</div>

						<div className="form-group row align-items-center mt-0 mb-0">
							<div className="col-md-4 text-left pl-0">
								<label className="form-label text-left">
									{
										props.customerControlFields?.tables[0]?.headers[7]
											?.display_name
									}
								</label>
							</div>
							<div className="col pr-0">
								<InputNumber
									id="stakeholder-name"
									value={formData.weightage}
									onChange={(e) => handleInputChange("weightage", e.value)}
									placeholder=""
									aria-describedby="username-help"
									className="w-full"
									mode="decimal"
									incrementButtonClassName="custom-increment-button"
									decrementButtonClassName="custom-decrement-button"
									showButtons
								/>
								{errors.weightage && (
									<small className="text-danger">
										{errors.weightage}
									</small>
								)}
							</div>
						</div>

						<div className="form-group row align-items-center mb-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{props.customerControlFields?.tables[0]?.headers[8]?.display_name}
								</label>
							</div>
							<div className="col pr-0">
								<InputTextElementElement
									id="refField"
									value={formData.display_name}
									onChange={(e) => handleInputChange("display_name", e.target.value)}
									required
									className="w-full"
								/>
								{errors.option_names && (
									<small className="text-danger">
										{errors.option_names}
									</small>
								)}
							</div>
						</div>
						<div className="form-group row align-items-center mb-0 mt-0">
							<div className="col-md-4 pl-0">
								<label className="form-label text-left">
									{props.customerControlFields?.tables[0]?.headers[9]?.display_name}
								</label>
							</div>
							<div className="col pr-0">
								<RadioElement
									options={[
										{ key: "Yes", name: "Yes" },
										{ key: "No", name: "No" },
									]}
									value={formData.option_status}
									onChangeRadio={(value) => {
										handleInputChange("option_status", value);
									}}
									className="radio-group-class" // Add any additional classes if necessary
									disabled={false} // Adjust the disabled prop as needed
								/>
							</div>

						</div>

						<div className="form-group row align-items-center mb-0">
							<div className="col-md-4 pl-0 pt-17">
								<p className="label-text">
									{
										props.customerControlFields?.tables[0]?.headers[10]
											?.display_name
									}
								</p>
							</div>
							<div className="col pr-0 d-flex justify-end">
								<ButtonElement className="new-option-button" type="button" icon="pi pi-plus" label=" New Option" onClick={handleAddOption} />
							</div>
						</div>

						<div>
							<DataTable
								value={option}
								columns={columns}
								editMode="cell"
								dataKey="_id"
								isNewField={true}
								isCheckbox={false}
								rowClick={rowClick}
							/>
						</div>
					</form>
				</div>
			</Dialog>
		</div>
	);
}
